import { Image } from "@phosphor-icons/react";

const AnalysingDocumentOverlay = () => {
	return (
		<div className="relative flex h-full w-full items-center justify-center overflow-hidden rounded-lg bg-gray-100">
			<Image size={48} weight="regular" className="text-gray-400" />
			<div className="absolute inset-0 bg-white/40 backdrop-blur-sm"></div>
			<div className="absolute inset-0 flex items-center justify-center">
				<div className="relative flex items-center gap-2 rounded-full bg-gray-200 px-4 py-2.5 overflow-hidden border border-white shadow-sm analysing-pill">
					<div className="relative flex items-center gap-2 w-full">
						<div className="absolute w-1 rounded h-full bg-gray-500 animate-line-move" />
						<Image size={16} weight="fill" className="text-gray-500 relative z-10" />
						<span className="text-sm font-medium text-gray-500 relative z-10">
							Analysing document
						</span>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AnalysingDocumentOverlay;
